module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Lounge_D4_cam5.d709edc5.jpg";